// VFM live fixes: gallery aspect-fit + product title/CTA rewriter + qspec box override
(function(){
  var CONTAINER_RATIO = 4 / 3;
  var TOLERANCE = 0.25;
  function applyFit(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    var r = img.naturalWidth / img.naturalHeight;
    var delta = Math.abs(r - CONTAINER_RATIO) / CONTAINER_RATIO;
    if (delta > TOLERANCE) img.classList.add('dv2-fit-contain');
    else img.classList.remove('dv2-fit-contain');
  }
  function scanGallery() {
    document.querySelectorAll('.dv2-gallery-main img').forEach(function(img){
      if (img.complete) applyFit(img);
      else img.addEventListener('load', function(){ applyFit(img); }, {once:true});
    });
  }

  function currentHandle() {
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Get the canonical product name from our qspec DB data (not document.title which
  // can be an outdated SEO title metafield with wrong casing).
  function getProductName() {
    var handle = currentHandle();
    if (window.VFM_QSPEC && handle && window.VFM_QSPEC[handle]) {
      return window.VFM_QSPEC[handle].name;
    }
    // Fallback: parse document.title
    var t = (document.title || '').replace(/\s*[-\u2013\u2014|]\s*The Vansmith.*$/i, '').trim();
    return t || null;
  }

  function rewriteTitles() {
    if (!currentHandle()) return;
    var name = getProductName();
    if (!name) return;
    document.querySelectorAll('.dv2-title, h1.dv2-title').forEach(function(el){
      if (el.textContent.trim() !== name) el.textContent = name;
    });
    var rx = /^Customize your .+? now$/i;
    document.querySelectorAll('a, button').forEach(function(el){
      var tx = el.textContent.trim();
      if (rx.test(tx)) {
        var newText = 'Customize your ' + name + ' now';
        if (tx !== newText) el.textContent = newText;
      }
    });
    // Also fix the page title tag
    var expectedTitle = name + ' - The Vansmith';
    if (document.title !== expectedTitle) document.title = expectedTitle;
    // Override base price from DB
    var handle = currentHandle();
    if (window.VFM_QSPEC && handle && window.VFM_QSPEC[handle] && window.VFM_QSPEC[handle].price) {
      var priceStr = '$' + window.VFM_QSPEC[handle].price.toLocaleString();
      var priceEl = document.querySelector('.dv2-price');
      if (priceEl && priceEl.textContent.trim() !== priceStr) priceEl.textContent = priceStr;
    }
  }

  function rewriteQspecs() {
    if (!window.VFM_QSPEC) return;
    var handle = currentHandle();
    if (!handle) return;
    var q = window.VFM_QSPEC[handle];
    if (!q) return;
    var pairs = [
      { lbl: 'Length',            val: q.length },
      { lbl: 'Seats / Sleeps',    val: q.seats && q.sleeps
                                         ? (q.seats === q.sleeps ? q.sleeps : q.seats + ' / ' + q.sleeps)
                                         : (q.sleeps || q.seats || '') },
      { lbl: 'Build time',        val: q.build },
      { lbl: 'Drive',             val: q.drive },
    ];
    var boxes = document.querySelectorAll('.dv2-qspecs .dv2-qspec');
    for (var i = 0; i < boxes.length && i < pairs.length; i++) {
      var p = pairs[i];
      if (!p.val) continue;
      var vEl = boxes[i].querySelector('.dv2-qspec-val');
      var lEl = boxes[i].querySelector('.dv2-qspec-lbl');
      if (vEl) vEl.textContent = p.val;
      if (lEl) lEl.textContent = p.lbl;
    }
    // Override the price note from admin DB (safe — only admin-editable, not user input)
    if (q.priceNote) {
      var noteEl = document.querySelector('.dv2-price-note');
      if (noteEl) noteEl.innerHTML = q.priceNote;
    }
  }

  function runAll() { scanGallery(); rewriteTitles(); rewriteQspecs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();
  setTimeout(runAll, 800);
  setTimeout(runAll, 2000);
})();


// --- Bivy Deluxe: fix oversized (4000px) carousel slide widths ---
(function(){
  if(location.pathname.indexOf('sprinter-bivy-deluxe')===-1)return;
  function fixDeluxeGallery(){
    var els=document.querySelectorAll('gp-product-images');
    if(!els.length)return;
    els.forEach(function(el){
      var raw=el.getAttribute('gp-data');
      if(!raw)return;
      try{
        var d=JSON.parse(raw);
        if(!d.product||!d.product.media)return;
        var needsFix=d.product.media.some(function(m){return(m.width||0)>=2000;});
        if(!needsFix)return;
        d.product.media=d.product.media.map(function(m){
          if((m.width||0)>=2000){
            m.width=1200;m.height=900;m.aspect_ratio=1.333;
            if(m.src&&m.src.indexOf('width=')===-1)m.src=m.src+(m.src.indexOf('?')!==-1?'&':'?')+'width=1200';
            if(m.preview_image){m.preview_image.width=1200;m.preview_image.height=900;m.preview_image.aspect_ratio=1.333;
              if(m.preview_image.src&&m.preview_image.src.indexOf('width=')===-1)m.preview_image.src=m.preview_image.src+(m.preview_image.src.indexOf('?')!==-1?'&':'?')+'width=1200';}
          }
          return m;
        });
        if(d.product.images)d.product.images=d.product.images.map(function(img){
          if(img&&typeof img==='object'&&(img.width||0)>=2000){img.width=1200;img.height=900;
            if(img.src&&img.src.indexOf('width=')===-1)img.src=img.src+(img.src.indexOf('?')!==-1?'&':'?')+'width=1200';}
          return img;
        });
        el.setAttribute('gp-data',JSON.stringify(d));
        var p=el.parentNode,n=el.nextSibling;
        p.removeChild(el);if(n)p.insertBefore(el,n);else p.appendChild(el);
      }catch(e){}
    });
  }
  setTimeout(fixDeluxeGallery,300);
  setTimeout(fixDeluxeGallery,1000);
})();
